import { wrap as withStyle } from 'utils/styles'

export default withStyle((props) => {
  const {
    activeStepIconBackground,
    activeStepIconColor,
    activeStepTextColor,
    finishedStepIconText,
  } = props.theme
  return `
    && {
      .ant-steps-item-progress {
        
        .ant-steps-item-icon {
          background-color: ${activeStepIconBackground};
          border-color: ${activeStepIconBackground};
        }
        
        .ant-steps-icon {
          color: ${activeStepIconColor};
        }
      }
      
      .ant-steps-item.ant-steps-item-progress .ant-steps-item-content .ant-steps-item-title {
        color: ${activeStepTextColor};
      }
      
      .ant-steps-item-finish {

        .ant-steps-item-icon {
          border-color: ${activeStepIconBackground};
        }

        .ant-steps-item-content .ant-steps-item-title {
          color: ${finishedStepIconText};
        }
      }
      
      .ant-steps-item-icon, .ant-steps-item-content {
        cursor: pointer;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }

      .ant-steps-item[aria-disabled] .ant-steps-item-icon,
      .ant-steps-item[aria-disabled] .ant-steps-item-content {
        cursor: not-allowed;
        pointer-events: none;
        opacity: 0.4;
      }
    }
  `
})
